import { Image } from "@clipboard-health/ui-components";
import { Box, Stack } from "@mui/material";
import { environmentConfig } from "@src/appV2/environment";
import { ClipboardLogo } from "@src/appV2/lib";
import { isRebrandingEnabled } from "@src/appV2/redesign/Rebranding/workerAppRebranding";

const MARKETPLACE_COLLAGE_URL = `${environmentConfig.REACT_APP_PUBLIC_ASSETS_BASE_URL}/images/onboarding/marketplace-collage.png`;

interface MarketplaceIntroSlideLayoutProps {
  readonly children: React.ReactNode;
}

export function MarketplaceIntroSlideLayout(props: MarketplaceIntroSlideLayoutProps) {
  const { children } = props;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        height: "100%",
      }}
    >
      <Box
        sx={{
          flex: 42,
          position: "relative",
          overflow: "hidden",
          display: "flex",
          justifyContent: "center",
          paddingX: "14px",
        }}
      >
        <Box sx={{ position: "relative", width: "100%" }}>
          <Image
            src={MARKETPLACE_COLLAGE_URL}
            alt="Marketplace collage"
            width="100%"
            sx={{ opacity: 0.9 }}
          />
          <Box
            sx={(theme) => ({
              position: "absolute",
              bottom: 0,
              left: 0,
              right: 0,
              height: "30%",
              // eslint-disable-next-line cbh-rules/no-inline-gradient -- TODO: migrate to theme palette gradient
              background: `linear-gradient(to bottom, transparent 0%, ${isRebrandingEnabled() ? theme.palette.background.tertiary : theme.palette.background.quaternary} 70%, ${isRebrandingEnabled() ? theme.palette.background.tertiary : theme.palette.background.quaternary} 100%)`,
              pointerEvents: "none",
            })}
          />
        </Box>
      </Box>

      <Box
        sx={{
          flex: 58,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingX: 5,
          minHeight: 0,
        }}
      >
        <Box
          sx={(theme) => ({
            marginTop: "30px",
            marginBottom: "30px",
            ...(isRebrandingEnabled()
              ? {
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }
              : {
                  backgroundColor: theme.palette.common.white,
                  padding: 3,
                  borderRadius: "22px",
                }),
          })}
        >
          <ClipboardLogo width={90} />
        </Box>

        <Stack spacing="20px" alignItems="center" sx={{ textAlign: "center" }}>
          {children}
        </Stack>
      </Box>
    </Box>
  );
}
